import React, { useState } from 'react';

import { Box, Text } from 'shared/components/display';
import ModuleRevisionCard from 'shared/components/molecules/ModuleRevisionCard/ModuleRevisionCard';
import moduleRevisionCardStyles from 'shared/components/molecules/ModuleRevisionCard/moduleRevisionCardStyles';
import ReviewOverlayModal from 'shared/components/molecules/ReviewOverlayModal';
import SwipeableContainer from 'shared/components/molecules/SwipableContainer/SwipeableContainer';

import { intl } from 'shared/lib/intl';
import { TEXT_VARIANTS } from 'shared/styles/text';
import { Revision } from 'shared/typings/revisions';

interface Props {
  submissionModuleId: number;
  revisions?: Revision[];
  openRevision: boolean;
  setOpenRevision: (open: boolean | Function) => void;
  moduleNum: number;
  mediaWidth: number;
  brandName: string;
  className?: string;
}
const ModuleRevisionModal: React.FC<Props> = ({
  submissionModuleId,
  revisions = [],
  openRevision,
  setOpenRevision,
  moduleNum,
  mediaWidth,
  brandName,
}) => {
  const [index, setIndex] = useState(0);

  return (
    <>
      <ReviewOverlayModal
        ariaLabel="Revision Cards"
        id="modal-revision"
        isOpen={openRevision}
        onRequestClose={setOpenRevision}
        mediaWidth={mediaWidth}
        dataCy="module-revision-modal"
      >
        <Box css={moduleRevisionCardStyles}>
          <Text className="revision-card__header" variant={TEXT_VARIANTS.H4}>
            {intl.formatMessage({ id: 'CAPTION_REVIEW_REVISION_HEADER' }, { moduleNum: moduleNum })}
          </Text>
        </Box>
        <SwipeableContainer pageIndex={index} updatePageIndex={setIndex} paginationPosition="left">
          {revisions.map((revision) => {
            return (
              <ModuleRevisionCard
                key={revision.id}
                revision={revision}
                moduleNum={moduleNum}
                brandName={brandName}
                submissionModuleId={submissionModuleId}
                revisionCount={revisions.length}
                toggleRevisionModal={setOpenRevision}
              />
            );
          })}
        </SwipeableContainer>
      </ReviewOverlayModal>
    </>
  );
};

export default ModuleRevisionModal;
